import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { BaseStbRiskProduct } from "./BaseStbRiskProduct";

export interface BoatProduct extends BaseStbRiskProduct {
  readonly name: INSURANCE_NAME_VALUE.BOAT;
  readonly boatType: BoatType;
  //  @Min(1000)
  //  @Max(2000000)
  readonly coverageAmount: number;
  //  @Min(0)
  //  @Max(3)
  readonly numberOfYearsAsOwner: number;
  //  @Min(1)
  //  @Max(50)
  readonly lengthInFeet: number;
  readonly modelYear: number;
  readonly harbourZipCode: string;
  readonly harbourSecurity: boolean;
  readonly memberOfRedningsselskapetCoastGuard: boolean;
  readonly trackingSystem: boolean;
  readonly hullAndEngineIdMarked: boolean;
  readonly engineHorsePower: number;
  readonly engineTopSpeed: number;
  readonly usedByYoungerDriver: boolean;
  readonly brandAndModel: string;
  readonly harbourName: string;
  readonly registrationNumber: string;
  readonly engineBrand: string;
  readonly motorNumber: string;
  readonly registeredInSmaabaatregisteret?: boolean;
}

export enum BoatType {
  SMALL_BOAT = "SMALL_BOAT",
  MOTOR_BOAT_INBOARDS = "MOTOR_BOAT_INBOARDS",
  MOTOR_BOAT_OUTBOARDS = "MOTOR_BOAT_OUTBOARDS",
  SAILBOAT = "SAILBOAT",
}

export const typeWithMotorOrSail = (type: BoatType): boolean =>
  type === BoatType.MOTOR_BOAT_INBOARDS ||
  type === BoatType.MOTOR_BOAT_OUTBOARDS ||
  type === BoatType.SAILBOAT;

export const typeWithMotor = (type: BoatType): boolean =>
  type === BoatType.MOTOR_BOAT_INBOARDS ||
  type === BoatType.MOTOR_BOAT_OUTBOARDS;

export const typeWithOutboardsMotor = (type: BoatType): boolean =>
  type === BoatType.MOTOR_BOAT_OUTBOARDS;
